import type { FaireProductEntity } from "../../entity_types/product";

export const p_nvytsnw8me: FaireProductEntity = {
  token: "p_nvytsnw8me",
  type: "product",
  name: "Really Happy Gift Bag - Medium",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/fc292578a3d81b5aca83ff74c15e256c797ff144b024f78fdb2ae6bef0c9f4ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55106d14a2ec7b159a1421779c4865c330eb0fd6d6ce74808e0d276df73fb04f.jpeg",
    "https://cdn.faire.com/fastly/1ff1a424b6616bf5a8ebfc0d0fce7832e9a5223d20b12b04d17d06030e50c818.webp",
    "https://cdn.faire.com/fastly/95a42f78f24f03563bd015f4745f7625fc8016d94f1d4d8b61c80585b156f919.webp",
  ],
  priceDollars: 3.5,
  description:
    "Yes, this gift bag is awesome. It's cute and fun and illustrated and might even outshine whatever you put inside! But it's that little die-cut tag that might just be the cutest thing we have ever seen. The Medium size is perfect for one of those really nice gifty candles. Or some of our other favorite gifts... assorted E. Frances products, 4-5 bags of chocolate chips, or 84 packs of gum. The Small size perfectly fits 2 to 5 boxes of Little Notes®. Or a chipmunk. The Large size fits 8 cans of new tennis balls or... you tell us what you get in there and give us some great ideas!",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:23.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
